import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReviewsSummaryComponent } from '@app/salon-details/salon-reviews/reviews-summary/reviews-summary.component';
import { SalonReviewsComponent } from '@app/salon-details/salon-reviews/salon-reviews.component';
import { TreatmentCategoryComponent } from '@app/salon-details/treatment-category/treatment-category.component';
import { SharedModule } from '@app/shared/shared.module';
import { ReviewsHeaderComponent } from '@app/salon-details/salon-details/reviews-header/reviews-header.component';

@NgModule({
  declarations: [
    SalonReviewsComponent,
    ReviewsSummaryComponent,
    ReviewsHeaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TreatmentCategoryComponent
  ],
  exports: [
    TreatmentCategoryComponent
  ]
})
export class SalonDetailsModule {}
